export const AuthenticationStorageKeys = {
  idToken: 'idToken',
  token: 'token',
  userInfo: 'userInfo',
  permissions: 'permissions',
};
